
var Model = require("../types/Model.js");

module.exports = Model({
	name: "header",
	init: init
});

function init() {

	this.tracker.on("personal:updated", function (data) {
		this.extend({
			who: {
				fname: data.fname,
				lname: data.lname,
				image: data.image
			}
		});
	}.bind(this));
	return this.push({
		who: {}
	});
}
